import { useEffect, useState } from 'react';
import { MODAL_TRANSITION_DURATION_WITH_SMALL_DELAY } from '@/app/components/search/components/Modal/OpenXModal/utils.ts';

export const useCanShowModal = (isOpen: boolean) => {
  const [canShowModal, setCanShowModal] = useState<boolean>(isOpen);
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  useEffect(() => {
    if (isOpen) {
      setCanShowModal(true);
    } else if (isFirstRender) {
      // avoid delay on first render
      setCanShowModal(false);
    } else {
      setTimeout(() => {
        // add delay to allow the animation to end
        setCanShowModal(false);
      }, MODAL_TRANSITION_DURATION_WITH_SMALL_DELAY);
    }
  }, [isOpen]);

  return {
    canShowModal,
  };
};
